import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
var RubriqNoFilesFound = function RubriqNoFilesFound() {
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center justify-content-center text-muted border rounded gap-3 p-5",
    style: {
      minHeight: '220px'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-magnifying-glass",
    className: "fs-3"
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.no-files-found"
  })));
};
export default RubriqNoFilesFound;